import React, { FunctionComponent } from "react";

const ArrowUpWithTailIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/arrows-diagrams/arrows/arrow-up
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 23.25L12 0.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M22.5 11.25L12 0.75 1.5 11.25"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default ArrowUpWithTailIcon;
